import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PlatformPageQuery } from "../graphql/queries";

export const usePlatformPageQuery = (options?: QueryHookOptions<any>) => {
  return useQuery(PlatformPageQuery, options);
};
